import { render } from "./CollectionPage.vue?vue&type=template&id=0b784c32&scoped=true"
import script from "./CollectionPage.vue?vue&type=script&lang=js"
export * from "./CollectionPage.vue?vue&type=script&lang=js"

import "./CollectionPage.vue?vue&type=style&index=0&id=0b784c32&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b784c32"]])

export default __exports__